<template>
  <div>
    <q-form ref="editForm">
      <c-card title="기본정보" class="cardClassDetailForm">
        <template slot="card-button">
          <q-btn-group outline>
            <c-btn
              v-if="editable"
              :url="saveUrl"
              :isSubmit="isSave"
              :param="processData"
              :mappingType="saveType"
              label="저장"
              icon="save"
              @beforeAction="saveData"
              @btnCallback="saveCallback"
            />
          </q-btn-group>
        </template>
        <template slot="card-detail">
          <div class="col-2">
            <c-dept
              label="팀명(반)"
              :required="true"
              :editable="editable"
              name="deptCd"
              v-model="processData.deptCd"
            />
          </div>
          <div class="col-2">
            <c-text
              :editable="editable"
              :required="true"
              label="공정명"
              name="processName"
              v-model="processData.processName"
            />
          </div>
          <div class="col-2">
            <c-text
              :editable="editable"
              label="원(재)료"
              name="mainMaterial"
              v-model="processData.mainMaterial"
            />
          </div>
          <div class="col-2">
            <c-text
              :editable="editable"
              type="number"
              label="근로자수(명)"
              name="workerCnt"
              v-model="processData.workerCnt"
            />
          </div>
          <div class="col-2">
            <c-text
              :editable="editable"
              label="생산품(기종)"
              name="productName"
              v-model="processData.productName"
            />
          </div>
          <div class="col-1">
            <c-text
              :editable="editable"
              :required="true"
              type="number"
              label="순번"
              name="orderNo"
              v-model="processData.orderNo"
            />
          </div>
          <div class="col-1">
            <c-checkbox
              :editable="editable"
              :isFlag="true"
              label="사용여부"
              name="useFlag"
              v-model="processData.useFlag"
            />
          </div>
        </template>
      </c-card>
      <!-- 기타 안전보건상 정보 -->
      <c-card title="기타 안전보건상 정보" class="cardClassDetailForm">
        <template slot="card-detail">
          <div class="col-6">
            <c-accident
              :editable="editable"
              multiple
              label="최근 3년간 재해발생사례"
              name="accidentHistoryDesc"
              v-model="processData.accidentHistoryDesc"
            />
          </div>
          <div class="col-6">
            <c-accident
              :editable="editable"
              multiple
              :isNear="true"
              label="아차사고사례"
              name="nearMissDesc"
              v-model="processData.nearMissDesc"
            />
          </div>
          <div class="col-6">
            <c-checkbox
              :editable="editable"
              codeGroupCd="MDM_PROCESS_WORKER_TYPE_CD"
              :isArray="false"
              label="근로자 구성 및 경력특성"
              name="workerTypeCd"
              itemText="codeName"
              itemValue="code"
              v-model="processData.workerTypeCd"
            />
          </div>
          <div class="col-2">
            <c-checkbox
              :editable="editable"
              codeGroupCd="MDM_PROCESS_TRANSPORT_TYPE_CD"
              type="edit"
              :isArray="false"
              itemText="codeName"
              itemValue="code"
              name="heavyTransportTypeCd"
              label="중량물 운반수단"
              v-model="processData.heavyTransportTypeCd"
            />
          </div>
          <div class="col-4">
            <c-text
              :editable="editable"
              label="장비명"
              name="heavyTransportEquip"
              v-model="processData.heavyTransportEquip"
            />
          </div>
          <div class="col-2">
            <c-checkbox
              :editable="editable"
              :isFlag="true"
              label="교대작업 유무"
              name="shiftFlag"
              v-model="processData.shiftFlag"
            />
          </div>
          <div class="col-2">
            <c-checkbox
              :editable="editable"
              :isFlag="true"
              label="중량물 인력취급유무"
              name="heavyManualFlag"
              v-model="processData.heavyManualFlag"
            />
          </div>
          <div class="col-2">
            <c-checkbox
              :editable="editable"
              codeGroupCd="MDM_PROCESS_HANDLING_TYPE_CD"
              type="edit"
              itemText="codeName"
              :isArray="false"
              itemValue="code"
              name="heavyManualTypeCd"
              label="취급형태(들기/밀기/끌기)"
              v-model="processData.heavyManualTypeCd"
            />
          </div>
          <div class="col-2">
            <c-checkbox
              :editable="editable"
              :isFlag="true"
              label="작업환경측정 실시"
              name="workEnvMeasureFlag"
              v-model="processData.workEnvMeasureFlag"
            />
          </div>
          <div class="col-2">
            <c-text
              :editable="editable"
              label="노출초과인자/수치"
              name="exposureOverValue"
              v-model="processData.exposureOverValue"
            />
          </div>
          <!-- <div class="col-2">
            <c-checkbox
              :editable="editable"
              :isFlag="true"
              label="특별안전보건교육 해당"
              name="specialSafetyEduFlag"
              v-model="processData.specialSafetyEduFlag"
            />
          </div> -->
          <div class="col-2">
            <c-checkbox
              :editable="editable"
              codeGroupCd="RAM_RISK_PROCESS_SPECIAL_EDU_TARGET_CD"
              type="edit"
              :isArray="false"
              itemText="codeName"
              itemValue="code"
              name="specialEduTargetCd"
              label="특별안전보건교육 해당"
              v-model="processData.specialEduTargetCd"
            />
          </div>
        </template>
      </c-card>
      <c-table
        ref="tableSop"
        title="단위작업 목록"
        :columns="gridSop.columns"
        :data="gridSop.data"
        :merge="gridSop.merge"
        :columnSetting="false"
        :isFullScreen="false"
        :usePaging="false"
        :editable="editable"
        gridHeight="550px"
        selection="multiple"
        rowKey="rowId"
        @innerBtnClicked="innerBtnClicked"
        @table-data-change="tableDataChange"
      >
        <template slot="table-button">
          <q-btn-group outline>
            <c-btn
              v-if="editable"
              :showLoading="false"
              label="단위작업 추가"
              icon="add"
              @btnClicked="addWork"
            />
            <c-btn
              v-if="editable"
              :showLoading="false"
              label="제외"
              icon="remove"
              @btnClicked="removeRow"
            />
          </q-btn-group>
        </template>
        <template v-slot:customArea="{ props, col }">
          <template v-if="col.name === 'unitWorkName'">
            <c-text-column
              :editable="editable"
              :col="col"
              :props="props"
              @datachange="datachange(props, col)"
            />
            <div v-if="editable">
              <q-btn-group outline class="ColumInnerBtnGroup">
                <q-btn
                  icon="add"
                  color="light-blue"
                  text-color="white"
                  class="ColumInnerBtn"
                  align="center"
                  @click.prevent="innerBtnClicked(col, props)"
                >
                  <q-tooltip>단위작업 추가</q-tooltip>
                </q-btn>
              </q-btn-group>
            </div>
          </template>
          <template v-else-if="col.name === 'equipName'">
            <c-text-column
              :editable="editable"
              :col="col"
              :props="props"
              @datachange="datachange(props, col)"
            />
            <div v-if="editable">
              <q-btn-group outline class="ColumInnerBtnGroup">
                <q-btn
                  icon="add"
                  color="green-6"
                  text-color="white"
                  class="ColumInnerBtn"
                  align="center"
                  @click.prevent="innerBtnClicked(col, props)"
                >
                  <q-tooltip>설비 추가</q-tooltip>
                </q-btn>
              </q-btn-group>
            </div>
          </template>
          <template v-else-if="col.name === 'chemName'">
            <c-text-column
              :editable="editable"
              :col="col"
              :props="props"
              @datachange="datachange(props, col)"
            />
            <div v-if="editable">
              <q-btn-group outline class="ColumInnerBtnGroup">
                <q-btn
                  icon="add"
                  color="deep-orange"
                  text-color="white"
                  class="ColumInnerBtn"
                  align="center"
                  @click.prevent="innerBtnClicked(col, props)"
                >
                  <q-tooltip>화학물질 추가</q-tooltip>
                </q-btn>
              </q-btn-group>
            </div>
          </template>
        </template>
      </c-table>
    </q-form>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
import { uid } from "quasar";
import selectConfig from "@/js/selectConfig";
import transactionConfig from "@/js/transactionConfig";
export default {
  name: "riskProcessManageDetail",
  props: {
    popupParam: {
      type: Object,
      default: () => ({
        riskProcessCd: "",
        plantCd: null,
      }),
    },
  },
  data() {
    return {
      editable: true,
      updateMode: false,
      isSave: false,
      saveUrl: "",
      saveType: "POST",
      listUrl: "",
      detailUrl: "",
      checkUrl: "",
      insertUrl: "",
      updateUrl: "",
      deleteUrl: "",
      wmrListUrl: "",
      wmrInsertUrl: "",
      wmrDeleteUrl: "",
      workerCharacterItems: [
        { code: "unskilledWorkerFlag", codeName: "1년미만 미숙련자" },
        { code: "femaleWorkerFlag", codeName: "여성근로자" },
        { code: "elderlyWorkerFlag", codeName: "고령근로자(만 55세 이상)" },
        { code: "irregularWorkerFlag", codeName: "비정규직(임시직)" },
        { code: "foreignWorkerFlag", codeName: "외국인 근로자" },
        { code: "disabledWorkerFlag", codeName: "장애근로자" },
      ],
      processData: {
        plantCd: null,
        riskProcessCd: "",
        processNo: "",
        processName: "",
        upProcessCd: "",
        upProcessName: "",
        processLevelCd: "10",
        processDesc: "",
        managementDepts: "",
        orderNo: 0,
        mainMaterial: "",
        workerCnt: 0,
        productName: "",
        useFlag: "Y",
        psmFlag: "N",
        workCycleCd: null,
        workingTime: null,
        temperature: "",
        workerTypeCd: "",
        shiftFlag: "N",
        workPermitFlag: "N",
        workEduFlag: "N",
        transportTypeCd: null,
        handlingTypeCd: null,
        accidentHistoryFlag: "N",
        accidentHistoryDesc: "",
        nearMissDesc: "",
        heavyTransportTypeCd: "",
        heavyTransportEquip: "",
        heavyManualFlag: "N",
        heavyManualTypeCd: "",
        workEnvMeasureFlag: "N",
        exposureOverFactor: "",
        exposureOverValue: null,
        exposureOverUnit: "",
        specialSafetyEduFlag: "N",
        specialEduTargetCd: "",
        regUserId: "",
        chgUserId: "",
        workList: [],
        deleteWorkList: [],
      },
      // 단위작업별 삭제된 설비/화학물질(그룹id 기준으로 저장 시 workList에 합쳐 보냄)
      groupDeletes: {},
      gridSop: {
        merge: [
          { index: 0, colName: "groupId" },
          { index: 1, colName: "groupId" },
          { index: 2, colName: "equipGroupId" },
          { index: 3, colName: "equipGroupId" },
        ],
        columns: [
          {
            name: "unitWorkNo",
            field: "unitWorkNo",
            label: "순번",
            align: "center",
            style: "width:70px",
            sortable: false,
            type: "number",
          },
          {
            name: "unitWorkName",
            field: "unitWorkName",
            label: "단위작업(순서)",
            align: "left",
            type: "text",
            style: "width:180px",
            // type: "custom",
            sortable: false,
          },
          {
            name: "equipName",
            field: "equipName",
            label: "기계,기구 및 설비명",
            align: "left",
            style: "width:200px",
            type: "custom",
            sortable: false,
          },
          {
            name: "equipQty",
            field: "equipQty",
            label: "수량(EA)",
            align: "right",
            style: "width:70px",
            sortable: false,
            type: "number",
          },
          {
            name: "chemName",
            field: "chemName",
            label: "화학물질명",
            align: "left",
            style: "width:200px",
            type: "custom",
            sortable: false,
          },
          {
            name: "riskGradeCd",
            field: "riskGradeCd",
            label: "일 취급량",
            align: "right",
            style: "width:80px",
            sortable: false,
            type: "number",
          },
          {
            name: "handlingTime",
            field: "handlingTime",
            label: "취급시간",
            align: "center",
            style: "width:80px",
            sortable: false,
            type: "date",
            dateType: "time",
          },
        ],
        data: [],
      },
      popupOptions: {
        target: null,
        title: "",
        visible: false,
        width: "70%",
        param: {},
        closeCallback: null,
      },
    };
  },
  computed: {},
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {
    this.init();
  },
  beforeDestroy() {},
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      // url setting
      this.detailUrl = selectConfig.ram.riskProcess.get.url;
      this.insertUrl = transactionConfig.ram.riskProcess.insert.url;
      this.updateUrl = transactionConfig.ram.riskProcess.update.url;
      this.saveUrl = transactionConfig.ram.riskProcess.insert.url;
      if (this.popupParam.riskProcessCd) {
        this.getDetail();
      }
    },
    getDetail() {
      this.$http.url = this.$format(
        this.detailUrl,
        this.popupParam.riskProcessCd
      );
      this.$http.type = "GET";
      this.$http.request((_result) => {
        this.processData = _result.data;
        // GET 응답엔 deleteWorkList가 없어서 매번 배열로 다시 채워줘야 함
        if (!this.processData.workList) this.processData.workList = [];
        this.processData.deleteWorkList = [];
        this.flattenWorkList();
      });
    },
    /**
     * workList(단위작업 > 설비목록/화학물질목록)를 단위작업 단위로 병합되는
     * 하나의 그리드 행 목록으로 펼침
     */
    flattenWorkList() {
      let rows = [];
      this.$_.forEach(this.processData.workList, (work) => {
        let groupId = work.riskWorkId || uid();
        let equipSource =
          work.equipList && work.equipList.length > 0 ? work.equipList : [{}];
        let chemSource =
          work.chemList && work.chemList.length > 0 ? work.chemList : [{}];
        // 설비 하나에 화학물질이 여러 개 딸릴 수 있으므로 equipSeq로 짝을 지어
        // 같은 equipGroupId를 부여(설비 컬럼 병합 유지). equipSeq가 없는
        // 구버전 데이터는 index 기준으로 매칭(하위호환)
        let usedChemIdx = [];
        this.$_.forEach(equipSource, (equip, equipIdx) => {
          let equipGroupId = equip.riskEquipId || uid();
          let matchedChems = [];
          if (equip.equipSeq) {
            this.$_.forEach(chemSource, (chem, chemIdx) => {
              if (
                usedChemIdx.indexOf(chemIdx) === -1 &&
                chem.equipSeq === equip.equipSeq
              ) {
                matchedChems.push(chem);
                usedChemIdx.push(chemIdx);
              }
            });
          }
          if (
            matchedChems.length === 0 &&
            usedChemIdx.indexOf(equipIdx) === -1 &&
            chemSource[equipIdx]
          ) {
            matchedChems = [chemSource[equipIdx]];
            usedChemIdx.push(equipIdx);
          }
          if (matchedChems.length === 0) matchedChems = [{}];
          this.$_.forEach(matchedChems, (chem) => {
            rows.push({
              rowId: uid(),
              groupId: groupId,
              riskWorkId: work.riskWorkId,
              unitWorkNo: work.unitWorkNo,
              unitWorkName: work.unitWorkName,
              workEditFlag: work.editFlag,
              equipGroupId: equipGroupId,
              riskEquipId: equip.riskEquipId || "",
              equipSeq: equip.equipSeq || equipIdx + 1,
              equipName: equip.equipName || "",
              equipQty: equip.equipQty || "",
              equipEditFlag: equip.editFlag,
              riskChemId: chem.riskChemId || "",
              chemSeq: chem.chemSeq || "",
              chemName: chem.chemName || "",
              riskGradeCd: chem.riskGradeCd || "",
              handlingTime: chem.handlingTime || "",
              chemEditFlag: chem.editFlag,
            });
          });
        });
        // 어떤 설비와도 짝지어지지 않은 화학물질(설비 없이 화학물질만 있는 경우)
        this.$_.forEach(chemSource, (chem, chemIdx) => {
          if (usedChemIdx.indexOf(chemIdx) === -1) {
            rows.push({
              rowId: uid(),
              groupId: groupId,
              riskWorkId: work.riskWorkId,
              unitWorkNo: work.unitWorkNo,
              unitWorkName: work.unitWorkName,
              workEditFlag: work.editFlag,
              equipGroupId: uid(),
              riskEquipId: "",
              equipSeq: "",
              equipName: "",
              equipQty: "",
              equipEditFlag: undefined,
              riskChemId: chem.riskChemId || "",
              chemSeq: chem.chemSeq || "",
              chemName: chem.chemName || "",
              riskGradeCd: chem.riskGradeCd || "",
              handlingTime: chem.handlingTime || "",
              chemEditFlag: chem.editFlag,
            });
          }
        });
      });
      this.gridSop.data = rows;
      this.groupDeletes = {};
    },
    /**
     * 그리드 행 목록을 다시 workList(단위작업 > 설비목록/화학물질목록) 구조로 합침
     */
    buildWorkList() {
      let groups = this.$_.groupBy(this.gridSop.data, "groupId");
      let workList = [];
      this.$_.forEach(groups, (rows, groupId) => {
        let first = rows[0];
        // 화학물질만 추가된 행은 위쪽 설비 행과 equipGroupId를 공유하므로
        // 설비 목록을 만들 때는 equipGroupId 기준으로 중복을 제거해야 함
        let equipRows = this.$_.uniqBy(rows, "equipGroupId");
        let equipList = this.$_.filter(
          this.$_.map(equipRows, (r) => ({
            riskEquipId: r.riskEquipId,
            riskWorkId: first.riskWorkId,
            equipSeq: r.equipSeq,
            equipName: r.equipName,
            equipQty: r.equipQty,
            editFlag: r.equipEditFlag,
            regUserId: this.$store.getters.user.userId,
          })),
          (equip) => equip.equipName || equip.riskEquipId
        );
        let chemList = this.$_.filter(
          this.$_.map(rows, (r) => ({
            riskChemId: r.riskChemId,
            riskWorkId: first.riskWorkId,
            chemSeq: r.chemSeq,
            // 화학물질이 어느 설비에 딸린 것인지 재조회 시 다시 짝지을 수 있도록 함께 저장
            equipSeq: r.equipSeq,
            chemName: r.chemName,
            riskGradeCd: r.riskGradeCd,
            handlingTime: r.handlingTime,
            editFlag: r.chemEditFlag,
            regUserId: this.$store.getters.user.userId,
          })),
          (chem) => chem.chemName || chem.riskChemId
        );
        let deletes = this.groupDeletes[groupId] || {
          deleteEquipList: [],
          deleteChemList: [],
        };
        workList.push({
          riskWorkId: first.riskWorkId,
          riskProcessCd: this.processData.riskProcessCd,
          unitWorkNo: first.unitWorkNo,
          unitWorkName: first.unitWorkName,
          editFlag: first.workEditFlag,
          regUserId: this.$store.getters.user.userId,
          equipList: equipList,
          chemList: chemList,
          deleteEquipList: deletes.deleteEquipList,
          deleteChemList: deletes.deleteChemList,
        });
      });
      this.processData.workList = workList;
    },
    saveData() {
      this.buildWorkList();
      if (this.popupParam.riskProcessCd) {
        this.saveUrl = this.updateUrl;
        this.saveType = "PUT";
      } else {
        this.saveUrl = this.insertUrl;
        this.saveType = "POST";
      }
      this.$refs["editForm"].validate().then((_result) => {
        if (_result) {
          window.getApp.$emit("CONFIRM", {
            title: "LBLCONFIRM",
            message: "MSGSAVE", // 저장하시겠습니까?
            type: "info", // success / info / warning / error
            // 확인 callback 함수
            confirmCallback: () => {
              this.processData.regUserId = this.$store.getters.user.userId;
              this.processData.chgUserId = this.$store.getters.user.userId;
              this.isSave = !this.isSave;
            },
            // 취소 callback 함수
            cancelCallback: () => {},
          });
        } else {
          window.getApp.$emit("APP_VALID_ERROR");
        }
      });
    },
    saveCallback(_result) {
      window.getApp.$emit("APP_REQUEST_SUCCESS");
      this.popupParam.riskProcessCd = _result.data;
      this.getDetail();
    },
    addWork() {
      let groupId = uid();
      let groupCount =
        this.$_.uniq(this.$_.map(this.gridSop.data, "groupId")).length * 5;
      this.gridSop.data.push(
        this.newRow({
          groupId: groupId,
          equipGroupId: uid(),
          equipSeq: 1,
          unitWorkNo: groupCount,
          unitWorkName: "",
          workEditFlag: "C",
        })
      );
    },
    /**
     * 단위작업(unitWorkName) / 설비(equipName) / 화학물질(chemName) 컬럼의
     * 인라인 추가버튼 - lawRegister.vue의 innerBtnClicked 패턴 참고
     */
    innerBtnClicked(col, props) {
      if (col.name === "unitWorkName") {
        let groupId = uid();
        let groupCount =
          this.$_.uniq(this.$_.map(this.gridSop.data, "groupId")).length * 5;
        this.gridSop.data.splice(
          props.rowIndex + 1,
          0,
          this.newRow({
            groupId: groupId,
            equipGroupId: uid(),
            equipSeq: 1,
            unitWorkNo: groupCount,
            unitWorkName: "",
            workEditFlag: "C",
          })
        );
      } else if (col.name === "equipName") {
        // 같은 단위작업 안에서 이미 쓰인 설비 개수 다음 순번을 새 설비의 equipSeq로 사용
        let nextEquipSeq =
          this.$_.uniqBy(
            this.$_.filter(this.gridSop.data, { groupId: props.row.groupId }),
            "equipGroupId"
          ).length + 1;
        this.gridSop.data.splice(
          props.rowIndex + 1,
          0,
          this.newRow({
            groupId: props.row.groupId,
            equipGroupId: uid(),
            equipSeq: nextEquipSeq,
            riskWorkId: props.row.riskWorkId,
            unitWorkNo: props.row.unitWorkNo,
            unitWorkName: props.row.unitWorkName,
            workEditFlag: props.row.workEditFlag,
            equipEditFlag: "C",
          })
        );
      } else if (col.name === "chemName") {
        this.gridSop.data.splice(
          props.rowIndex + 1,
          0,
          this.newRow({
            groupId: props.row.groupId,
            riskWorkId: props.row.riskWorkId,
            unitWorkNo: props.row.unitWorkNo,
            unitWorkName: props.row.unitWorkName,
            workEditFlag: props.row.workEditFlag,
            // 새 설비를 추가하는 게 아니라 화학물질만 추가하는 것이므로
            // 위 행과 같은 설비(equipGroupId + 설비값)를 그대로 물려받아
            // equipName/equipQty 컬럼이 병합된 채로 보이게 함
            equipGroupId: props.row.equipGroupId,
            riskEquipId: props.row.riskEquipId,
            equipSeq: props.row.equipSeq,
            equipName: props.row.equipName,
            equipQty: props.row.equipQty,
            equipEditFlag: props.row.equipEditFlag,
            chemEditFlag: "C",
          })
        );
      }
    },
    newRow(overrides) {
      return this.$_.assign(
        {
          rowId: uid(),
          groupId: "",
          riskWorkId: "",
          unitWorkNo: "",
          unitWorkName: "",
          workEditFlag: undefined,
          equipGroupId: "",
          riskEquipId: "",
          equipSeq: "",
          equipName: "",
          equipQty: "",
          equipEditFlag: undefined,
          riskChemId: "",
          chemSeq: "",
          chemName: "",
          riskGradeCd: "",
          handlingTime: "",
          chemEditFlag: undefined,
        },
        overrides
      );
    },
    /**
     * customArea(type:'custom')로 직접 그린 컬럼은 c-table이 자동으로
     * table-data-change를 emit하지 않으므로 같은 로직을 별도로 호출
     */
    datachange(props, col) {
      this.tableDataChange(props, col);
    },
    /**
     * 셀 직접 수정 시 신규(C)가 아닌 항목은 수정(U)으로 표시
     */
    tableDataChange(props, col) {
      let row = props.row;
      if (
        (col.name === "unitWorkNo" || col.name === "unitWorkName") &&
        row.workEditFlag !== "C"
      ) {
        row.workEditFlag = "U";
      } else if (
        (col.name === "equipName" || col.name === "equipQty") &&
        row.equipEditFlag !== "C"
      ) {
        row.equipEditFlag = row.riskEquipId ? "U" : "C";
      } else if (
        (col.name === "chemName" ||
          col.name === "riskGradeCd" ||
          col.name === "handlingTime") &&
        row.chemEditFlag !== "C"
      ) {
        row.chemEditFlag = row.riskChemId ? "U" : "C";
      }
    },
    removeRow() {
      let selectData = this.$refs["tableSop"].selected;
      if (!selectData || selectData.length === 0) {
        window.getApp.$emit("ALERT", {
          title: "LBLGUIDE", // 안내
          message: "MSGNOITEMS", // 선택된 항목이 없습니다.
          type: "warning", // success / info / warning / error
        });
        return;
      }

      if (!this.processData.deleteWorkList) {
        this.processData.deleteWorkList = [];
      }
      this.$_.forEach(selectData, (row) => {
        let groupRows = this.$_.filter(this.gridSop.data, {
          groupId: row.groupId,
        });
        let firstRow = groupRows[0];
        if (row.rowId === firstRow.rowId) {
          // 대표행(첫 번째 행) 선택 → 그룹 전체 삭제
          if (firstRow.riskWorkId) {
            this.processData.deleteWorkList.push({
              riskWorkId: firstRow.riskWorkId,
            });
          }
          this.gridSop.data = this.$_.reject(this.gridSop.data, {
            groupId: row.groupId,
          });
          delete this.groupDeletes[row.groupId];
        } else {
          // 설비/화학물질 행만 삭제
          if (row.riskEquipId || row.riskChemId) {
            if (!this.groupDeletes[row.groupId]) {
              this.groupDeletes[row.groupId] = {
                deleteEquipList: [],
                deleteChemList: [],
              };
            }
            if (row.riskEquipId) {
              this.groupDeletes[row.groupId].deleteEquipList.push({
                riskEquipId: row.riskEquipId,
              });
            }
            if (row.riskChemId) {
              this.groupDeletes[row.groupId].deleteChemList.push({
                riskChemId: row.riskChemId,
              });
            }
          }
          this.gridSop.data = this.$_.reject(this.gridSop.data, {
            rowId: row.rowId,
          });
        }
      });
      this.$refs["tableSop"].$refs["compo-table"].clearSelection();
    },
  },
};
</script>
